module.exports = __webpack_public_path__ + "49957ab4e3ce6c9b5f6aba9c42370925.svg";